import React from "react";
import { Col } from "reactstrap";
import { ExerciseType } from "../../components/heading/heading";
import { SuggestedTime } from "../../components/badges/suggested_time";
import { TimerCountDown } from "../../components/timer/timercountdown";
import { isNovium, isB2C } from "../../libs/env";
import { useState } from "react";
export const AssessmentHeader = ({
  isReview,
  creatQuizDataAndSubmit,
  data,
  isStopTimer,
  setIsStopTimer,
  timer,
  setShowTimeWarning,
  showTimeWarning,
}) => {
  const [saveOnTimeOver, SetSaveOnTimeOver] = useState(false);
  let class_name = "test-bg-placement";
  if(window.location.origin.includes(isNovium))
  {
     class_name = "bg-blue text-dark";
  }
  else if (isB2C.some(domain => window.location.origin.includes(domain)))
  {
    class_name = "bg-purple text-dark";
  }
  return (
     <div
      className={`px-4 p-3 ${class_name} row rounded-header border border-bottom-0`}
      xs="1"
      sm="1"
      md="4"
      >
        <div className="col-xl-4 col-xxl-4 col-lg-4 col-md-4  col-sm-12 lg-px-1 d-flex">
          <Col className="col-6 d-flex align-items-center test-title text-nowrap">
            <div>
              <ExerciseType title={data.assessment_type + " Test"} />
            </div>
          </Col>
          <Col md className="sm-display col-6 center justify-content-end text-nowrap">
              <span className="pt-1">
              <b>
                { isReview ? (
                  <span className={`bg-white rounded-2 p-1`}>
                    <div className="inline">
                      <span className="text-dark">Time: </span><span>00:00</span>
                    </div>
                  </span>
                ): data && data.status  && (
                    <TimerCountDown
                      isStopTimer={isReview ? true : isStopTimer}
                      data={data}
                      localSpentTime={timer}
                      test_time_out={data.test_time_out}
                      setShowTimeWarning={setShowTimeWarning}
                      totalTimeInSeconds={data.time_allowed_in_minutes}
                      onStop={(props) => {
                        if (!saveOnTimeOver && data.test_time_out) {
                          creatQuizDataAndSubmit();
                          alert("Your test was automatically submitted because you ran out of time.");
                          SetSaveOnTimeOver(true);
                          setIsStopTimer(true);
                        }
                      }}
                    />
                )}
              </b>
              </span>
            </Col>
        </div>

        <div className="col-xl-8 col-xxl-8 col-lg-8 col-md-8  col-sm-12 lg-display">
          <div className="col-12 d-flex">
            <Col md className="col-6 center text-nowrap test-parts">
              <span className="p-1">
              <b>
                { isReview ? (
                  <span className={`bg-white rounded-2 p-1`}>
                    <div className="inline">
                      <span className="text-dark">Time: </span>  <span>00:00</span>
                    </div>
                  </span>
                ): data && data.status  && (
                    <TimerCountDown
                      isStopTimer={isStopTimer}
                      data={data}
                      localSpentTime={timer}
                      test_time_out={data.test_time_out}
                      setShowTimeWarning={setShowTimeWarning}
                      totalTimeInSeconds={data.time_allowed_in_minutes}
                      onStop={(props) => {
                        if (!saveOnTimeOver && data.test_time_out) {
                          creatQuizDataAndSubmit();
                          alert("Your test was automatically submitted because you ran out of time.");
                          SetSaveOnTimeOver(true);
                          setIsStopTimer(true);
                        }
                      }}
                    />
                )}
              </b>
              </span>
            </Col>
            <Col md className="col-6 center justify-content-end">
              <SuggestedTime time={data.time_allowed_in_minutes} />
            </Col>
          </div>
        </div>
      </div>
  );
};
